import { useCallback, useEffect, useState } from 'react';
import { Button, Form, FormItem, Input, Paragraph, Text, Row } from '@/components/atoms';
import { Alert, Divider, Spin } from 'antd';
import api from '@/api';
import { Link } from 'react-router-dom';
import { API_AUTH_FIND, PATH_AUTH_LOGIN } from '@/constants/constant';
import { ErrorMessage } from '@/constants/message';
import Title from '@/components/atoms/text/Title';
import SubTitle from '@/components/atoms/text/SubTitle';

const FindAccountPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [account, setAccount] = useState('');
  const [error, setError] = useState('');

  const findAccount = useCallback((values) => {
    setLoading(true);
    setError('');
    api
      .post(API_AUTH_FIND, 'pauth.PbFindAccountRequest', values)
      .then(({ data }) => {
        setLoading(false);
        setSuccess(true);
        setAccount(data.account);
      })
      .catch((e) => {
        setLoading(false);
        setSuccess(false);
        setAccount('');
        setError(e.response.data.message);
      });
  }, []);

  return (
    <Spin spinning={loading}>
      <Title>계정 찾기</Title>
      <SubTitle>이름과 연락처로 계정을 찾습니다.</SubTitle>
      {!success && (
        <Form form={form} onFinish={findAccount} layout="vertical">
          <FormItem
            name="name"
            validateFirst
            rules={[
              { required: true, message: ErrorMessage.auth.name.empty },
              { pattern: /^[a-zA-Z가-힣]+/, message: ErrorMessage.auth.name.invalid },
            ]}
          >
            <Input placeholder="이름" />
          </FormItem>
          <FormItem
            name="phone"
            rules={[
              { required: true, message: ErrorMessage.auth.phone.empty },
              { pattern: /^01(?:0|1|[6-9])[.-]?(\d{3}|\d{4})[.-]?(\d{4})$/, message: ErrorMessage.auth.phone.invalid },
            ]}
          >
            <Input placeholder="핸드폰 번호( - 제외 )" />
          </FormItem>
          {error && <Alert type="error" message={error} banner />}
          <FormItem>
            <Button htmlType="submit" type="success" size="large" block loading={loading} disabled={loading} style={{ margin: '10px auto' }}>
              확인
            </Button>
          </FormItem>
          <Row justify="center">
            <Link className="text-black link success-link" to={PATH_AUTH_LOGIN} style={{ marginTop: '20px' }}>
              로그인 하러가기
            </Link>
          </Row>
        </Form>
      )}
      {success && (
        <Row justify="center" align="middle" style={{ padding: '20px', flexDirection: 'column' }}>
          <Paragraph>
            아이디 : <Text strong>{account}</Text>
          </Paragraph>
          <Button type="success" size="large" block style={{ marginTop: '30px' }}>
            <Link to={PATH_AUTH_LOGIN}>로그인 하러가기</Link>
          </Button>
        </Row>
      )}
    </Spin>
  );
};

export default FindAccountPage;
